import React from 'react';
import { BlockContextValue } from './blockContextInterface';

const Context = React.createContext<BlockContextValue | null>(null);

export function createBlockContextProvider() {
    return {
        Provider: Context.Provider,
        useContext() {
            const context = React.useContext(Context);
            if (!context) {
                throw new Error(
                    'useBlockContext must be used within a BlockContextProvider'
                );
            }
            return context;
        },
    };
}

export type BlockContextProvider = ReturnType<typeof createBlockContextProvider>;
